import {Repository} from '@s-ui/domain'

/**
 * @interface
 */
export default class UpdateThirdPartyUserRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  update({id, firstName, lastName, email, isEmailConfirmed, phoneNumber}) {
    throw new Error('[UpdateThirdPartyUserRepository#update] must be implemented')
  }
}
